export type ColorScheme = {
  name: string;
  gradientStart: string;
  gradientStop: string;
  blob: string;
  icon: string;
};

// Ordered by cycle position (color-schemes.csv). Schemes are assigned to category
// cards by their position in the carousel arrangement, not by category.
export const COLOR_SCHEMES: readonly ColorScheme[] = [
  {
    name: "Soft blue",
    gradientStart: "#E2ECF6",
    gradientStop: "#F4F8FC",
    blob: "#F4F8FC",
    icon: "#8CBAE3",
  },
  {
    name: "Pink-lavender",
    gradientStart: "rgba(233,196,234,0.31)",
    gradientStop: "#FDF9FD",
    blob: "#FDF9FD",
    icon: "#E9C4EA",
  },
  {
    name: "Coral / terracotta",
    gradientStart: "#FFEAE9",
    gradientStop: "#FEF5F2",
    blob: "#FEF5F2",
    icon: "#CC7E5C",
  },
  {
    name: "Sage green",
    gradientStart: "rgba(225,237,210,0.79)",
    gradientStop: "#F5FAF0",
    blob: "#F5FAF0",
    icon: "#9BB97E",
  },
  {
    name: "Warm amber / tan",
    gradientStart: "#FFEDD2",
    gradientStop: "#FEF8EB",
    blob: "#FEF8EB",
    icon: "#E7B96D",
  },
  {
    name: "Magenta / berry",
    gradientStart: "#F8DCE8",
    gradientStop: "#FCF0F5",
    blob: "#FCF0F5",
    icon: "#D88AAE",
  },
  {
    name: "Mint",
    gradientStart: "#D6F0E5",
    gradientStop: "#ECF8F2",
    blob: "#ECF8F2",
    icon: "#7CC3A0",
  },
  {
    name: "Sky / cyan blue",
    gradientStart: "#DDF0F7",
    gradientStop: "#F0F7FB",
    blob: "#F0F7FB",
    icon: "#76B4D4",
  },
  {
    name: "Warm orange",
    gradientStart: "#FFEEDD",
    gradientStop: "#FEF8F0",
    blob: "#FEF8F0",
    icon: "#E9924C",
  },
  {
    name: "Plum / deep purple",
    gradientStart: "#E8DEED",
    gradientStop: "#F5EFF8",
    blob: "#F5EFF8",
    icon: "#9B7BAE",
  },
  {
    name: "Pale yellow",
    gradientStart: "#FFF8CD",
    gradientStop: "#FFFCEC",
    blob: "#FFFCEC",
    icon: "#F3DE7F",
  },
  {
    name: "Slate blue",
    gradientStart: "#DDE9F3",
    gradientStop: "#F0F5F9",
    blob: "#F0F5F9",
    icon: "#8FB2D6",
  },
  {
    name: "Rose / blush pink",
    gradientStart: "#FAEAEA",
    gradientStop: "#FDF6F6",
    blob: "#FDF6F6",
    icon: "#E89BA0",
  },
  {
    name: "Fresh green",
    gradientStart: "#E4F2E4",
    gradientStop: "#F3F9F3",
    blob: "#F3F9F3",
    icon: "#7DB87D",
  },
  {
    name: "Mustard / honey",
    gradientStart: "#F5E8C2",
    gradientStop: "#FBF5E2",
    blob: "#FBF5E2",
    icon: "#C9A94A",
  },
  {
    name: "Teal / aqua",
    gradientStart: "#CFE6E6",
    gradientStop: "#E4F2F2",
    blob: "#E4F2F2",
    icon: "#9BBFBF",
  },
  {
    name: "Lavender / violet",
    gradientStart: "#DED7F4",
    gradientStop: "#F1EDF7",
    blob: "#F1EDF7",
    icon: "#ABA0DB",
  },
  {
    name: "Beige / khaki",
    gradientStart: "#F5EFE5",
    gradientStop: "#FAF7F2",
    blob: "#FAF7F2",
    icon: "#D4B896",
  },
  {
    name: "Indigo / navy",
    gradientStart: "#D8DEEC",
    gradientStop: "#ECEFF5",
    blob: "#ECEFF5",
    icon: "#6B7BA8",
  },
  {
    name: "Neutral gray",
    gradientStart: "#E2E5EA",
    gradientStop: "#F2F4F7",
    blob: "#F2F4F7",
    icon: "#8B92A0",
  },
];
